import LoaderSpiner from "../../../../components/loaderSpiner";
import { useLazyGetDashboardSearchQuery } from "../../../../services/Api";
import MonthlyGrowth from "../travellerProfile/MonthlyGrowth";
import ActivityDistribution from "./ActivityDistribution";
import DestinationsAnalytics from "./DestinationsAnalytics";
import MonthlyGrowthRate from "./MonthyGrowthRate";
import NationalityComposition from "./NationalityComposition";
import PackingListsAnalytics from "./PackingListsAnalytics";
import PackingStyleDistribution from "./PackingStyleDistribution";
import SpendingMetrics from "./SpendingMetrics";
import TechItem from "./TechItemDistribution";
import ToiletryDistribution from "./ToiletryDistribution";
import TravellerProfileChart from "./TravelerProfileCharts";
import TravelersTable from "./TravelersTable";
import React, { useEffect } from "react";

function Result() {
  const [trigger, { data, isLoading, error }] =
    useLazyGetDashboardSearchQuery();

  useEffect(() => {
    trigger();
  }, [trigger]);

  if (isLoading) {
    return <LoaderSpiner />;
  }

  if (error) {
    return (
      <div>
        Unable to fetch data. Please check your internet connection and try
        again.: {error.message}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div>
        <div className="bg-white rounded-[1.75rem] w-full shadow p-6 mb-8 mt-10">
          <h1 className="mb-6 font-['Roboto_Mono'] text-2xl font-bold">
            Traveler Trends & Analytics
          </h1>
          <div className="grid md:grid-cols-7 grid-cols-1 md:gap-4 gap-y-4">
            <div className="col-span-2">
              <TravellerProfileChart data={data?.data} loading={isLoading} />
            </div>
            {/* <div className="col-span-2">
              <PackingListsAnalytics data={data?.data} loading={isLoading} />
            </div> */}
            <div className="col-span-2">
              <NationalityComposition data={data?.data} loading={isLoading} />

              {/* <DestinationsAnalytics data={data?.data} loading={isLoading} /> */}
            </div>
            <div className="col-span-3">
              <MonthlyGrowthRate />
            </div>
          </div>
        </div>
        <div className="bg-white rounded-[1.75rem] w-full shadow p-6 mb-8 mt-10">
          <h1 className="mb-6 font-['Roboto_Mono'] text-2xl font-bold">
            Packing list saved by Users{" "}
          </h1>
          <div className="grid md:grid-cols-4 grid-cols-1 md:gap-4 gap-y-4">
            <div className="">
              <PackingStyleDistribution data={data?.data} loading={isLoading} />
            </div>
            <div className="">
              <ToiletryDistribution data={data?.data} loading={isLoading} />
            </div>
            <div className="">
              <TechItem data={data?.data} loading={isLoading} />
            </div>
            <div className="">
              <ActivityDistribution data={data?.data} loading={isLoading} />
            </div>
          </div>
        </div>

        {/* <div className="bg-white rounded-[1.75rem] w-full shadow p-6 mb-8 mt-10">
          <h1 className="mb-6 font-['Roboto_Mono'] text-2xl font-bold">
            Traveler Trends & Analytics
          </h1>
          <div className="grid md:grid-cols-7 grid-cols-1 md:gap-4 gap-y-4">
            <div className="col-span-2"></div>
            <div className="col-span-2"></div>
            <div className="col-span-3">
              <SpendingMetrics data={data?.data} loading={isLoading} />
            </div>
          </div>
        </div> */}
        <div className="grid md:grid-cols-2">
          <div className="md:col-span-2 bg-white p-6 rounded-[1.75rem] shadow-md mb-4 md:mb-0 h-fit overflow-x-auto">
            <h2 className="mb-4 font-['Roboto_Mono'] text-2xl font-bold">
              Top 10 Packing Lists
            </h2>
            <div className="overflow-x-auto">
              <TravelersTable data={data?.data} loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Result;
